import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from spinner--spokes.svg
 */
export default function SpinnerSpokesIcon(props) {
  return _jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 64 64",
    "data-component": "SpinnerSpokesIcon",
    ...props,
    children: _jsxs("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "6",
      children: [_jsx("path", {
        d: "M32 16V4",
        children: _jsx("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: "0;1;.8;.65;.45;.3;.15;0"
        })
      }), _jsx("path", {
        d: "m43.314 20.686 8.485-8.485",
        children: _jsx("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".15;0;1;.8;.65;.45;.3;.15"
        })
      }), _jsx("path", {
        d: "M48 32h12",
        children: _jsx("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".3;.15;0;1;.8;.65;.45;.3"
        })
      }), _jsx("path", {
        d: "m43.314 43.314 8.485 8.485",
        children: _jsx("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".45;.3;.15;0;1;.85;.65;.45"
        })
      }), _jsx("path", {
        d: "M32 48v12",
        children: _jsx("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".65;.45;.3;.15;0;1;.8;.65;"
        })
      }), _jsx("path", {
        d: "m20.686 43.314-8.485 8.485",
        children: _jsx("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".8;.65;.45;.3;.15;0;1;.8"
        })
      }), _jsx("path", {
        d: "M16 32H4",
        children: _jsx("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: "1;.85;.6;.45;.3;.15;0;1;"
        })
      }), _jsx("path", {
        d: "m20.686 20.686-8.485-8.485",
        children: _jsx("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: "0;1;.8;.65;.45;.3;.15;0"
        })
      })]
    })
  });
}
//# sourceMappingURL=SpinnerSpokes.js.map